import React, { useEffect } from "react";
import { connect } from "react-redux";

import { withI18n } from "@quantum/i18n";

import { compose, isNil } from "ramda";

import {
  type ActionCreator,
  getTipoCalculoSelecionado,
  getAnosSelecionados,
  selecionarTipoCalculo,
  isModoSeries,
} from "../../../../../state";
import {
  type Id,
  ID_TIPO_CALCULO_PONTUAL,
  ID_TIPO_CALCULO_VARIACAO_PERCENTUAL,
} from "../../../../../model";

import "./selecao-tipo-calculo.css";

type TipoCalculo = {
  id: Id,
  chaveTraducao: string,
  traducao?: ?string,
};

const OPCOES_TIPO_CALCULO: Array<TipoCalculo> = [
  {
    id: ID_TIPO_CALCULO_PONTUAL,
    chaveTraducao: "configuracaoRelatorio.pontual",
  },
  {
    id: ID_TIPO_CALCULO_VARIACAO_PERCENTUAL,
    chaveTraducao: "configuracaoRelatorio.periodos.AnaliseHorizontal",
  },
];

type Props = {
  listaTipoCalculo: Array<TipoCalculo>,
  tipoCalculoSelecionado: Id,
  anosSelecionados: Array<Id>,
  selecionarTipoCalculo: ActionCreator,
};

const SelecaoTipoCalculo = ({
  listaTipoCalculo,
  tipoCalculoSelecionado,
  anosSelecionados,
  selecionarTipoCalculo,
}: Props) => {
  const onChangeTipoCalculo = event =>
    selecionarTipoCalculo(parseInt(event.target.value, 10));

  useEffect(() => {
    if (isNil(tipoCalculoSelecionado)) {
      selecionarTipoCalculo(ID_TIPO_CALCULO_PONTUAL);
    }
  }, [tipoCalculoSelecionado, selecionarTipoCalculo]);

  return (
    <div className="ConfiguracaoMedida SelecaoTipoCalculo">
      {listaTipoCalculo.map(opcao => (
        <div className="SelecaoTipoCalculo__opcao" key={opcao.id}>
          <input
            type={"radio"}
            value={opcao.id}
            onChange={onChangeTipoCalculo}
            checked={opcao.id === tipoCalculoSelecionado}
            disabled={
              !isModoSeries &&
              opcao.id === ID_TIPO_CALCULO_VARIACAO_PERCENTUAL &&
              anosSelecionados.length > 1
            }
          />
          <label className="ConfiguracaoMedida__label">{opcao.traducao}</label>
        </div>
      ))}
    </div>
  );
};

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaTipoCalculo: OPCOES_TIPO_CALCULO.map(opcao => ({
        ...opcao,
        traducao: ownProps.translate(opcao.chaveTraducao) || opcao,
      })),
      tipoCalculoSelecionado: getTipoCalculoSelecionado(state),
      anosSelecionados: getAnosSelecionados(state),
    }),
    {
      selecionarTipoCalculo,
    }
  )
)(SelecaoTipoCalculo);
